/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {FormattedDate, FormattedMessage, FormattedTime, useIntl} from 'react-intl'
import {statusColor} from '../../../../../../../_metronic/helpers/custom/funcs/statusColor'
import {ITtn} from '../../../core/_models'
import {useQuery} from 'react-query'
import {getTTNStatuses} from '../../../core/_requests'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'

type Props = {
  ttn: ITtn
}

const TtnStatusCell: FC<Props> = ({ttn}) => {
  const intl = useIntl()
  const {data: ttnStatuses} = useQuery(
    ['ttnStatuses', intl.locale, ttn.code],
    () => {
      return getTTNStatuses(ttn.code.toString())
    },
    {keepPreviousData: true, retry: false}
  )
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [ttn.id, ttnStatuses])
  return (
    <div>
      {ttnStatuses && (
        <div className='d-flex flex-column align-items-start'>
          <div className='d-flex align-items-center gap-2'>
            <div className='d-flex flex-column'>
              <span className='text-dark fw-bold fs-6'>{ttnStatuses.statusLogs[0]?.name}</span>
              {ttnStatuses.statusLogs[0]?.createdAt && (
                <span className='text-dark fw-bold fs-7'>
                  <FormattedDate
                    year='numeric'
                    month='numeric'
                    day='numeric'
                    value={ttnStatuses.statusLogs[0]?.createdAt}
                  />
                </span>
              )}
            </div>
            {ttnStatuses.statusLogs && ttnStatuses.statusLogs.length > 1 && (
              <>
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-light btn-active-light-primary'
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                >
                  <i className='fas fa-ellipsis-v'></i>
                </button>
                <div
                  className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-3 mw-300px mw-lg-400px w-100'
                  data-kt-menu='true'
                >
                  <div className='menu-item px-3'>
                    <div className='table-responsive'>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 mb-0 text-center'>
                        <tbody>
                          {ttnStatuses.statusLogs.map((log:any, index: number) => (
                            <tr key={index}>
                              <td>
                                <span className='text-dark fw-bold fs-6'>{log.name}</span>
                              </td>
                              <td>
                                <span className='text-dark fw-bold fs-7'>
                                  <FormattedDate
                                    year='numeric'
                                    month='numeric'
                                    day='numeric'
                                    value={log.createdAt}
                                  />{' '}
                                  <FormattedTime value={log.createdAt} />
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {!ttnStatuses && ttn?.status && (
        <div>
          <span
            className={`p-1 fs-8 fs-md-7 me-2 mb-1 fw-semobold  StatusBar__status ${statusColor(
              ttn.status.name
            )}`}
          >
            <FormattedMessage id={`TTNS.STATUS_COL.${ttn.status.name.toUpperCase()}`} />
          </span>
          {ttn.status.date && ttn.status.date !== '0000-00-00 00:00:00' && (
            <div className='d-flex flex-column'>
              <span className='text-dark fw-bold fs-6'>
                <FormattedDate
                  year='numeric'
                  month='numeric'
                  day='numeric'
                  value={new Date(ttn.status.date)}
                />
              </span>
              <span className='text-muted fw-normal fs-6'>
                <FormattedTime
                  value={new Date(ttn.status.date)}
                  hour='numeric'
                  minute='numeric'
                  second='numeric'
                />
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export {TtnStatusCell}
